module.exports = __webpack_public_path__ + "img/scan.96a7ae5.svg";